import React from 'react';
import classNames from 'classnames';
import InstantConfirm from '@lt/components/icons-react/userflow/InstantConfirm';
import { useTranslation } from '@lt/localization';
import type { CurrencyType } from 'src/utils/stringUtils';
import { CurrencyFormat } from '@lt/components';
import type { Availability } from '../../types';
import HotelCardAvailability from '../HotelCardAvailability';
import HotelCardDates from './components/HotelCardDates/HotelCardDates';
import styles from './hotelCardPrice.module.css';

type HotelCardPriceProps = {
  instantConfirm: boolean;
  isMobile: boolean;
  isFlexDates: boolean;
  isMapCard: boolean;
  price: number;
  currencyCode: CurrencyType;
  availability: Availability;
  isHotelOnly: boolean;
  datesInfo?: string;
};

const HotelCardPrice: React.FC<HotelCardPriceProps> = ({
  isMobile,
  instantConfirm,
  isFlexDates,
  isMapCard,
  price,
  currencyCode,
  availability,
  isHotelOnly,
  datesInfo = '',
}) => {
  const { t } = useTranslation();

  const showInstantConfirmIcon = instantConfirm && !isHotelOnly;

  return (
    <div className={styles.priceContainer}>
      <HotelCardAvailability
        availability={availability}
        isHotelOnly={isHotelOnly}
      />

      <div
        className={classNames(styles.styledHotelCardPrice, {
          [styles.styledHotelCardPriceMobile]: isMobile,
        })}
      >
        {showInstantConfirmIcon && (
          <InstantConfirm className={styles.instantConfirmIcon} />
        )}
        <div
          className={classNames(styles.styledPrice, {
            [styles.styledPriceMapCard]: isMapCard,
            [styles.styledPriceMobile]: isMobile,
            [styles.styledPriceDesktop]: !isMobile && !isMapCard,
          })}
        >
          {`${t('filters.prices.from')} `}
          <CurrencyFormat value={price} currencyCode={currencyCode} />
        </div>
      </div>

      {isFlexDates ? <HotelCardDates datesInfo={datesInfo} /> : null}
    </div>
  );
};

export default HotelCardPrice;
